export default __webpack_public_path__ + "static/media/pdf_1.ad4de722.svg";